import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useCustomerEnrichApiKey = () => {
  const customerId = useCustomerId()
  return useQuery({
    queryKey: ['customer', customerId, 'enrich_api_key'],
    queryFn: () => get(`/management/customers/${customerId}/enrich_api/key`),
    retry: false,
  })
}
